import request from '../utils/request';
import { IListResult, IResult } from '../global';

const relation = {
  myself: function(galleryid: string) {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/userinfo',
        method: 'get',
        data: {
          galleryid,
          useTotal: 0
        },
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  person: function(
    galleryid: string,
    personid: number,
    imageid?: number,
    openid?: string
  ) {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/face3/personshow',
        method: 'get',
        data: {
          galleryid,
          personid,
          imageid,
          openid,
          useTotal: 0
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  personAlbum: function(galleryid: string, personid: number, page: number = 1) {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/face3/galleryv2',
        method: 'get',
        data: {
          personid,
          galleryid,
          page
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  myselfAlbum: function(galleryid: string, page: number = 1) {
    return new Promise<IListResult>((resolve, reject) => {
      request({
        url: '/api/v2/face/galleryv2',
        method: 'get',
        data: {
          personid: 0,
          galleryid: galleryid,
          page
        },
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  follower: function() {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/face3/relation',
        method: 'get',
        data: {
          galleryid: window.dataDetail
            ? window.dataDetail.id
            : window.gallery.id,
          total: 0
        },
        headers: {
          Authorization: request.token
        }
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  }
};

export default relation;
